export const QUERY_KEY = {
  // 유저 정보 관련
  checkLogin: 'checkLogin',
  userInfo: 'userInfo',
  withdrawalUserInfo: 'withdrawalUserInfo',
  suitability: 'suitability',

  // 메인 화면
  home: 'home',

  // 뉴스
  news: 'news',

  // 청약 작품 관련
  product: 'product',
  productSales: 'productSales',
  productSellHistorySummary: 'productSellHistorySummary',
  productSellHistory: 'productSellHistory',

  // 콘텐츠 관련
  article: 'article',
  articles: 'articles',
  articleCategories: 'articleCategories',

  // 투자 내역 관련
  assetSummary: 'assetSummary',
  holdingProductList: 'holdingProductList',
  productSold: 'productSold',
  userProduct: 'userProduct',
  userProductPurchases: 'userProductPurchases',
  userProductSell: 'userProductSell',
  userProductSettle: 'userProductSettle',

  // 출금 계좌 관련
  withdrawalAccount: 'withdrawalAccount',
  withdrawalFee: 'withdrawalFee',
  bankList: 'bankList',

  // 예치금 계좌 관련
  depositAccount: 'depositAccount',
  cashTransaction: 'cashTransaction',

  // 약관 관련
  termsList: 'termsList',
  terms: 'terms',

  // 1:1 문의 관련
  qnaList: 'qnaList',
  qna: 'qna',
  qnaChats: 'qnaChats',

  // 공지 관련
  noticeList: 'noticeList',
  notice: 'notice',

  // 알림 관련
  notificationList: 'notificationList',
  unreadNotificationCount: 'unreadNotificationCount',

  // 이벤트 관련
  event: 'event',
  eventList: 'eventList',

  // 공시 관련
  disclosure: 'disclosure',
  disclosureCategories: 'disclosureCategories',
  disclosureDetail: 'disclosureDetail',

  // 카탈로그 관련
  catalog: 'catalog',

  // 이용약관/처리방침 관련
  homeTerms: 'homeTerms',

  // unmasked
  unmasked: 'unmasked',
} as const
